"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
var _index = require("../../types/index.cjs");
function createClient(api) {
  async function list(newsroomId, {
    search
  } = {}) {
    const url = _routing.routing.newsroomContactsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      contacts
    } = await api.get(url, {
      query: {
        search
      }
    });
    return contacts;
  }
  async function get(newsroomId, contactId) {
    const url = _routing.routing.newsroomContactsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      contact
    } = await api.get(`${url}/${contactId}`);
    return contact;
  }
  async function search(newsroomId, {
    search,
    query
  } = {}) {
    const url = _routing.routing.newsroomContactsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      contacts
    } = await api.get(url, {
      query: {
        search,
        query: _index.Query.stringify(query)
      }
    });
    return contacts;
  }
  async function order(newsroomId, payload) {
    const url = _routing.routing.newsroomContactsOrderUrl.replace(':newsroom_id', String(newsroomId));
    return api.post(url, {
      payload
    });
  }
  async function create(newsroomId, payload) {
    const url = _routing.routing.newsroomContactsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      contact
    } = await api.post(url, {
      payload
    });
    return contact;
  }
  async function update(newsroomId, contactId, payload) {
    const url = _routing.routing.newsroomContactsUrl.replace(':newsroom_id', String(newsroomId));
    const {
      contact
    } = await api.patch(`${url}/${contactId}`, {
      payload
    });
    return contact;
  }
  async function doDelete(newsroomId, contactId, force = false) {
    const url = _routing.routing.newsroomContactsUrl.replace(':newsroom_id', String(newsroomId));
    const query = force ? {
      force: true
    } : {};
    return api.delete(`${url}/${contactId}`, {
      query
    });
  }
  return {
    list,
    get,
    search,
    order,
    create,
    update,
    delete: doDelete
  };
}